import React, { useState, useRef, useEffect } from "react"
import { TabView, TabPanel } from "primereact/tabview"
import { CardBody, Col, Container, Row, DropdownItem, DropdownMenu, } from "reactstrap"
// import { Col, Row } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { MultiSelect } from "primereact/multiselect"
import { useForm } from "react-hook-form"
import { useLocation } from "react-router-dom"
import axios from "axios"
import moment from "moment"
import { emailValidation, MaxLengthValidation, MinLengthValidation, onlyAlphabetsandSpaces, onlyNumbers, passwordPattern } from "utils/Constants"
import Modal from "react-bootstrap/Modal";
import { TreeSelect } from 'primereact/treeselect';
import { Eye, EyeOff } from 'lucide-react';
import { InputTextarea } from "primereact/inputtextarea"


import { setPageData } from "store/actions"
import { useDispatch, useSelector } from "react-redux"

const User_groups_admin = ({ type }) => {
    const dispatch = useDispatch();
    const { first, rows, totalRecord } = useSelector(
        state => state.calendar.pagination
    )
    const dt = useRef(null);
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const initialTabIndex = Number(queryParams.get("selectedTab")) || 0
    const [isGroupFormVisible, setIsGroupFormVisible] = useState(false)
    const [selectedOptions, setselectedOptions] = useState([])
    const [groupList, setGroupList] = useState([])
    const [availableOptions, setavailableOptions] = useState([])
    const [nodes, setNodes] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [street1, setStreet1] = useState('');
    const [street2, setStreet2] = useState('')
    const [selectedCity, setSelectedCity] = useState(null);
    const [addCountries, setAddCountries] = useState([]);
    const [addStates, setAddStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null)
    const [postalCode, setPostalCode] = useState('');
    const [userRoles, setUserRoles] = useState([])
    const [selectedLabel1, setSelectedLabel1] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [groupitem, setgroupitem] = useState([])
    const [selectedGroupKey, setSelectedGroupKey] = useState(null);
    const [categoriesitem, setcategoriesitem] = useState([])
    const { register, handleSubmit, watch, formState: { errors }, trigger, control, setValue, reset } = useForm();
    const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);
    const [pagegroup, setpagegroup] = useState({ page: 0, rows: 10 });

    const [visible, setVisible] = useState(false)
    const [address, setAddress] = useState("")
    const [userList, setUserList] = useState([])
    const [formVisible, setFormVisible] = useState(false) // Controls the form visibility
    const [isEditMode, setIsEditMode] = useState(null) // True when editing, false when adding
    const [isEditModegrop, setIsEditModegrop] = useState(null) // True when editing, false when adding


    const resetFormgroup = () => {
        reset2()
        setIsGroupFormVisible(false) // Hide the form
        setIsEditModegrop(null)
    }

    // Handle delete
    const handleDeleteUser = async () => {
        let id = deleteRowIduser

        try {
            const response = await axios.delete(`/api/v1/users/${id}/`);
            if (response.status === 200) {
                // Optionally, show a success message
                fetchUserManagementDetails(); // Refresh the user list
                setSmShowuser(false)
                setSuccessAlert(true)
            }
        } catch (error) {

            console.error("Error deleting user:", error);
            // Optionally, show an error notification
        }
    };

    const fetchAllgroups = async (page, size,) => {
        try {
            const response = await axios.get(`/api/v1/user-group/?page=${page}&size=${size}`)
            // const transformedDataroles = response.data.results.map((city) => ({
            //     name: city.company_name,
            //     id: city.company_id,
            // }));
            setGroupList(response.data.results || []);
            // setTotalRecords1(response.data.count)

            dispatch(setPageData({
                first: (page - 1) * size,
                rows: size,
                totalRecords: response?.data?.count || 0,
            }));

        }
        catch (error) {
            //console.log('error occured ', error.message)
        }
    }

    useEffect(() => {

        const page = Math.floor(first / rows) + 1
        fetchAllgroups(page, rows, type);

    }, [first, rows, type]);


    const onPageChangegroup = (event) => {
        setpagegroup({ page: event.page, rows: event.rows });
    };

    const fetchAlluserlist = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-recruiters/`)
            const transformedDataroles = response.data.map((city) => ({
                name: `${city.first_name || ''} ${city.middle_name || ''} ${city.last_name || ''}`.trim(),
                id: city.id,
            }));
            setavailableOptions(transformedDataroles);

        }
        catch (error) {
            //console.log('error occured ', error.message)
        }
    }
    const [errorhandling, seterrorhandling] = useState("")
    const handleFormSubmitgroup = async (data) => {


        const req = {
            group_name: data.Group_Name,
            description: data.Description,
            members: selectedOptions

        };

        if (!isEditedgrp) {
            try {
                var rolepost = await axios.post(`/api/v1/user-group/`, req,);
                if (rolepost.data) {
                    const page = Math.floor(first / rows) + 1
                    fetchAllgroups(page, rows, type);
                    setIsGroupFormVisible(false)
                    setSmShowcreate(true)
                    setsmcreate("Added new group")
                    setSuccessMessage("group created successfully")

                }

            } catch (error) {
               if (error.response.data.group_name || error.response.data.error) {
                    seterrorhandling(error.response.data.group_name || error.response.data.error)
                }

            }
        } else {
            try {
                var response = await axios.put(`/api/v1/user-group/${isEditModegrop}/`, req,);
                if (response.data) {
                    const page = Math.floor(first / rows) + 1
                    fetchAllgroups(page, rows, type);
                    setIsGroupFormVisible(false)
                    setSmShowcreate(true)
                    setsmcreate("Updated group")
                    setSuccessMessage("group updated successfully")
                }

            } catch (error) {
                if (error.response.data.group_name || error.response.data.error) {
                    seterrorhandling(error.response.data.group_name || error.response.data.error)
                }

            }
        }
    };
    const handleDeletegroup = async () => {
        let id = deleteRowIdusergroup
        await axios.delete(`/api/v1/user-group/${id}/`)
            .then((resp) => {

                setsmShowusergroup(false)
                setSmShowcreate(true)
                setsmcreate("Deleted group")
                setSuccessMessage("group deleted successfully")
                const page = Math.floor(first / rows) + 1
                fetchAllgroups(page, rows, type);
            })
            .catch((error) => {

                console.log("on submit delete error ", error);
            });
    }


    const handleEditGroup = (rowData,) => {
        console.log(rowData)

        setValue2('Group_Name', rowData.group_name);
        setValue2('Description', rowData.description);
        setselectedOptions(rowData.members)
        setIsEditModegrop(rowData?.id)
        // setValue2('password', rowData.password);
    }


    useEffect(() => {

        fetchAlluserlist()
    }, [])


    /////////////////////////////////////////////////////naveen pss////////////////////////////

    const { register: register2, formState: { errors: errors2 }, handleSubmit: handleSubmit2, getValues: getValues2, setValue: setValue2, trigger: trigger2, reset: reset2, } = useForm({ mode: "onBlur" });

    const { register: register1, formState: { errors: errors1 }, handleSubmit: handleSubmit1, getValues: getValues1, setValue: setValue1, trigger: trigger1, reset: reset1, } = useForm({ mode: "onBlur" });

    const [loading, setLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });

    const [searchText, setSearchText] = useState('');
    const [smShow, setSmShow] = useState(false)
    const [smShowuser, setSmShowuser] = useState(false)
    const [smShowusergroup, setsmShowusergroup] = useState(false)
    const [smShowcreate, setSmShowcreate] = useState(false)
    const [smcreate, setsmcreate] = useState("Added")
    const [successMessage, setSuccessMessage] = useState("")
    const [successAlert, setSuccessAlert] = useState(false);
    const [deleteRowId, setDeleteRowID] = useState(null)
    const [deleteRowIduser, setDeleteRowIDuser] = useState(null)
    const [deleteRowIdusergroup, setDeleteRowIDusergroup] = useState(null)
    const [isEdited, setisEdited] = useState(false);
    const [isEditedgrp, setisEditedgrp] = useState(false);
    const [editId, setEditId] = useState(null);
    const [disable, setDisable] = useState(false);

    const [showPassword, setShowPassword] = useState(false);

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };


    return (
        <React.Fragment>
            <Container fluid={true}>
                <div className="">
                    <div className="container-fluid mt-3 ps-3">
                        <div className="usermanagement-main">
                            <div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 className="heading-sz mb-3">User Groups</h3>
                                    <Button
                                        label="Add Group"
                                        icon="pi pi-users"
                                        className="p-button-primary mb-3"
                                        onClick={() => { reset2(); setisEditedgrp(false); setselectedOptions([]); setIsGroupFormVisible(true) }}
                                    />
                                </div>

                                {isGroupFormVisible && (
                                    <> <form onSubmit={handleSubmit2(handleFormSubmitgroup)}>
                                        <div className="p-3 border rounded mt-3">
                                            {/* <h4>{groupData.groupName ? "Edit Group" : "Add Group"}</h4> */}

                                            {/* Group Name */}
                                            <div className="field mb-2">
                                                <label htmlFor="groupName">Group Name<span className="text-danger">*</span></label>
                                                <InputText id="Group_Name" className="w-full" placeholder="Enter Group Name"
                                                    {...register2("Group_Name", {
                                                        required: "Group  name is required",
                                                        pattern: {
                                                            value: /^[A-Za-z][A-Za-z-\s&]+$/, message: "Only alphabets and First character must be a letter. Only 50 characters"
                                                        }
                                                    })}
                                                    onKeyUp={() => { trigger2("Group_Name"); seterrorhandling("") }} />
                                                {errors2.Group_Name && <small className="text-danger">{errors2.Group_Name.message}</small>}
                                            </div>

                                            {/* Description */}
                                            <div className="field mb-2">
                                                <label htmlFor="description">Description</label>
                                                <InputText className="w-full" placeholder="Enter Description "
                                                    {...register2("Description", {
                                                        pattern: {
                                                            value: /^[A-Za-z][A-Za-z\s\-&]*$/,
                                                            message: "Only alphabets, spaces, hyphens, and ampersands allowed. First character must be a letter. Only 50 characters"
                                                        }
                                                    })}
                                                    onKeyUp={() => { trigger2("Description"); }} />
                                                {errors2.Description && <small className="text-danger">{errors2.Description.message}</small>}

                                            </div>

                                            {/* Multi-Select Dropdown */}
                                            <div className="field mb-2">
                                                <label htmlFor="multiSelect">
                                                    Select Options
                                                </label>
                                                <MultiSelect
                                                    style={{ border: "1px solid #ced4da", borderRadius: "5px", }}
                                                    id="multiSelect"
                                                    className="w-full"
                                                    value={selectedOptions}
                                                    onChange={e => { setselectedOptions(e.value) }}
                                                    options={availableOptions}
                                                    optionLabel="name"
                                                    optionValue="id"
                                                    placeholder="Choose options"
                                                    display="chip" // Displays selected options as chips
                                                />
                                            </div>
                                            <small className='form-text text-danger'>{errorhandling}</small>

                                            <div className="d-flex justify-content-end mt-3">
                                                <Button
                                                    label={isEditModegrop ? "Update" : "Save"}
                                                    icon="pi pi-check"
                                                    className="p-button-primary me-2"
                                                    type="submit"
                                                />
                                                <Button
                                                    label="Cancel"
                                                    icon="pi pi-times"
                                                    className="p-button-danger"
                                                    onClick={resetFormgroup}
                                                />
                                            </div>
                                        </div>
                                    </form>


                                    </>
                                )}

                                {/* DataTable Section */}

                                <div className="datatable-size">
                                    <DataTable
                                        ref={dt}
                                        value={groupList}
                                        loading={loading}
                                        // paginator
                                        //  first={pagegroup.page * pagegroup.rows}
                                        // lazy
                                        // rows={pagegroup.rows} totalRecords={totalRecords1} onPage={onPageChangegroup} 
                                        // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        // rowsPerPageOptions={[10, 20, 50, totalRecords1]} // Dynamic row options including "All"
                                        dataKey="candidate_id"

                                    >
                                        <Column field="group_name" header="Group Name" />
                                        <Column field="description" header="Description" />
                                        <Column field="member_names" header="Members"
                                            body={rowData => rowData.member_names?.join(", ") || "-"}
                                        />
                                        <Column field="date_created" header="Date Created" body={(rowData) => moment(rowData.date_created).format('DD-MM-YYYY')} />
                                        <Column
                                            style={{ width: "10%" }}
                                            body={(rowData, { rowIndex }) => (
                                                <div>
                                                    <Button
                                                        icon="pi pi-pencil"
                                                        className="p-button-text p-button-sm me-2"
                                                        onClick={() => {
                                                            setIsGroupFormVisible(true)
                                                            setisEditedgrp(true);
                                                            handleEditGroup(rowData);

                                                        }}
                                                    />
                                                    <Button
                                                        icon="pi pi-trash"
                                                        className="p-button-text p-button-sm p-button-danger"
                                                        onClick={() => {
                                                            setsmShowusergroup(true);
                                                            setDeleteRowIDusergroup(rowData?.id)
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            header="Actions"
                                        />
                                    </DataTable>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </Container>



            <Modal size="md" show={successAlert} onHide={() => setSuccessAlert(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Success</h1></Modal.Header>
                <div className="text-center m-3"> </div>
                <h4 className="text-center">Deleted  Successfully</h4>
                <div className="text-center m-3">
                    <button className="btn btn-primary" onClick={() => setSuccessAlert(false)} > OK </button>
                </div>
            </Modal>
            <Modal size="md" show={smShowuser} onHide={() => setSmShowuser(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Delete</h1></Modal.Header>
                <div className="text-center m-3 text-danger">  </div>
                <h4 className="text-center m-2"> Are you sure you want to delete this </h4>
                <div className="text-center m-3">
                    <Button className="btn btn-primary m-1" onClick={() => setSmShowuser(false)} >Cancel</Button>
                    <button className="btn btn-primary m-1" onClick={handleDeleteUser}> Delete </button>
                </div>
            </Modal>
            <Modal size="md" show={smShowusergroup} onHide={() => setsmShowusergroup(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Delete</h1></Modal.Header>
                <div className="text-center m-3 text-danger">  </div>
                <h4 className="text-center m-2"> Are you sure you want to delete this </h4>
                <div className="text-center m-3">
                    <Button className="btn btn-primary m-1" onClick={() => setsmShowusergroup(false)} >Cancel</Button>
                    <button className="btn btn-primary m-1" onClick={handleDeletegroup}> Delete </button>
                </div>
            </Modal>


            <Modal size="md" show={smShowcreate} onHide={() => setSmShowcreate(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 ">{smcreate}</h1></Modal.Header>
                <div className="text-center m-3 text-danger">  </div>
                <h4 className="text-center m-2"> {successMessage}  </h4>
                <div className="text-center m-3">
                    <Button className="btn btn-primary m-1" onClick={() => setSmShowcreate(false)} >ok</Button>

                </div>
            </Modal>

        </React.Fragment>
    )
}

export default User_groups_admin;
